import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import '../../ecs/containers/Home.scss';

import { Button, PageHeaderControl } from '@salesforce/design-system-react';

import { default as Actions } from '../actions';
import { default as ECSActions } from '../../ecs/actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import {
  EctHeader,
  ExperimentOverview,
  ExperimentEditWizard,
  ExperimentWelcomeMat
} from '../components/';
import { McMenu } from '../../ecs/components/';

export class ExperimentDashboard extends Component {
  createNewExperiment() {
    this.props.actions.openModal('experimentWizard', {
      mode: 'create',
      experiment: { status: 'DRAFT' }
    });
  }

  newExperimentButton() {
    const { formatMessage } = this.props.intl;
    const isReadonly = this.props.flags?.flags?.isReadonly;

    return () => (
      <PageHeaderControl>
        <Button
          id="new-test-button"
          label={formatMessage({
            id: 'components.experiment.new.button'
          })}
          onClick={this.createNewExperiment.bind(this)}
          disabled={isReadonly}
        />
      </PageHeaderControl>
    );
  }

  render() {
    const {
      actions,
      assets,
      contentBuilder,
      experiments,
      location,
      modals,
      toast
    } = this.props || [];
    const flags = this.props.flags?.flags;
    return (
      <McMenu flags={flags} history={this.props.history} route="/experiments">
        <BrandBand>
          <EctHeader
            route={this.props.match}
            onRenderActions={this.newExperimentButton()}
          />
          <ExperimentOverview
            actions={actions}
            modals={modals}
            experiments={experiments}
            flags={flags}
            location={location}
            toast={toast}
          />
          <ExperimentEditWizard
            actions={actions}
            assets={assets}
            contentBuilder={contentBuilder}
            context={'overview'}
            modals={modals}
            experiments={experiments}
            finishDisabled={true}
          />
          <ExperimentWelcomeMat
            actions={this.props.actions}
            modals={this.props.modals}
            welcomeMat={this.props.welcomeMat}
            name="experiment"
          />
        </BrandBand>
      </McMenu>
    );
  }
}

ExperimentDashboard.contextTypes = {
  router: PropTypes.object
};

ExperimentDashboard.propTypes = {
  actions: PropTypes.object,
  assets: PropTypes.object,
  contentBuilder: PropTypes.object,
  experiments: PropTypes.object.isRequired,
  flags: PropTypes.object,
  location: PropTypes.object,
  modals: PropTypes.object,
  toast: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    contentBuilder: state.ecs.contentBuilder,
    experiments: state.experiments,
    flags: state.ecs.flags,
    modals: state.modals,
    toast: state.toast,
    welcomeMat: state.welcomeMat.experiment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...Actions, ...ECSActions, ...CommonActions },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ExperimentDashboard));
